import React from 'react';
import styled from 'styled-components';
import { ThemeProvider } from '../../../components-core/packages/components-core/dist/theme-provider';

//LAYOUT
import { 
    Container, 
    ContainerWrap, 
    ContainerPadding,
    ContainerGutter,
    ContainerHorizontalAlignment
} from '../../../components-core/packages/components-core/dist/container';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';
import { Layout } from '../../../components-core/packages/components-core/dist/layout';
import CustomAccordion from '../custom-accordion/CustomAccordion';
import ModelComparisonDescription from './ModelComparisonDescription';
import caddy from './caddy-exclusive.png'

const UnorderedList = styled.div`
    display: grid;
    grid-gap: 52px;
    grid-template-columns: repeat(3, 1fr);
    list-style: none;

    @media screen and (max-width: 960px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media screen and (max-width: 560px) {
        grid-template-columns: repeat(1, 1fr);
    }
`;


class ModelComparisonCars extends React.Component {
    renderDescriptionAreas() {

        const dummyData = dataListMode1;
        const newData = [];

        dummyData.forEach(dataObj => {
            if (dataObj.title) {
                newData.push(dataObj);
            }
        })

        return newData.map(data => 
            <li style={{ float: 'left', position: 'relative' }} >
                <ModelComparisonDescription data={data}/>
            </li>
        )
    
}

render() {

    const ContainerPaddingGrid = ContainerPadding.grid002;

    return (
        <ThemeProvider>
            <Container 
                padding={{
                    left: {
                        [Breakpoints.b560]: ContainerPaddingGrid,                            
                    },
                    right: {
                        [Breakpoints.b560]: ContainerPaddingGrid,                            
                    }
                }}
            >
                <UnorderedList>
                    {this.renderDescriptionAreas()}
                </UnorderedList>
            </Container>
        </ThemeProvider>
    )
}


}

export default ModelComparisonCars;


const dataListMode1 = [
    {
        'title': 'Caddy Exclusive',
        'price': '₺ ' + '100',
        'image': caddy,
        'backgroundColor':'#aaaa',
        'modelLink':'https://www.google.com/'

    },
    {
        'title': 'Caddy Maxi Van',
        'price': '₺ ' + '100',
        'image': caddy,
        'backgroundColor':'#aaaa',
        'modelLink':'https://www.google.com/'
    },
    {
        'title': 'Caddy Comfortline',
        'price': '₺ ' + '100',
        'image': caddy,
        'backgroundColor':'#aaaa',
        'modelLink':'https://www.google.com/'

    },


]